import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({
    data() {
        return {
            page: 1
        };
    }
})
export default class Pagination extends Vue {
    @Prop(Number)
    value: number;

    page: number;

    mounted() {
        this.page = this.value;
    }

    @Watch('value')
    onChangeValue(value) {
        this.page = value;
    }
}
